module.exports = "\nprecision mediump float;\n\nvarying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\n\nvoid main(void)\n{\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    float threshold = texture2D(mask, vFilterCoord).r;\n\n    float mask = smoothstep(1.0 - alpha * 1.4, 1.0 - alpha * 1.4 + 0.4, threshold);\n\n    float intensity = pow(min(1.0, alpha * 5.0), 5.0);\n\n    gl_FragColor = vec4(original*mask*intensity);\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/glsl/mask/mask_fs.glsl
 ** module id = 725
 ** module chunks = 2
 **/